<template>
  <div v-show="isCardActiveLocal" class="contentCards" vs-align="center" :style="{ position: 'relative'}">
    <div>
      <div class="vx-row mt-2">
        <div class="vx-col w-full mb-2" style="text-align: center;">
          <h5>Please wait while the results are retrieved...</h5>
          <vs-progress indeterminate color="primary"></vs-progress>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
  export default {
    components: {
      
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      }
    },
    data() {
      return {
        
      }
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;

          
        }
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) { }
      },
    },
    methods: {
      
    }
  };
</script>

<style lang="scss">
  .contentCards {
    margin: auto;
  }
</style>
